import {h, Component} from 'preact'

import designDomain from '../domain/designDomain'
import designService from '../service/designService'

import constants from '../constants'
import util from '../util'

export default class AsideMyDesigns extends Component {
    constructor() {
        super()
        this.state = {
            isMemberLoading:    false,
            memberDesigns:      [],
        }
    }

    componentDidMount() {
        this.setState({ isMemberLoading: true })
        designService.getMemberDesigns(window.data.member.id).then( response => {
            const designs = response.data.map(design => new designDomain.Design(design, util.sizes))

            this.setState({ memberDesigns: designs })
            this.setState({ isMemberLoading: false })
        })
    }

    goToDesign(design) {
        window.location.href = constants.appPrefix + '/design?id=' + design.id
    }

    removeDesign(design) {
        window.ConfirmationModal.show({
            title: 'Are you sure?',
            body: 'This design will be removed from all galleries.',
            acceptLabel: 'Yes, remove',
            declineLabel: 'Cancel',
            onAccept: () => {
                designService.removeDesign(design.id).then(response => {
                    this.setState({memberDesigns: this.memberDesigns.filter(it => it.id !== design.id)})
                })
            }
        })
    }

    render (props, state) {
        const memberDesignsContent = state.memberDesigns.map(design => {
            return (
                <div class="component" data-component="design" style="width: 50%; padding: .5rem">
                    <div class="design-card" data-component="design">
                        <div class="img-wrap">
                            <img src={ constants.RENDERER_DOMAIN + '/design/thumbnail/' + design.id } />
                        </div>

                        <h6>{ design.sizeLabel }</h6>
                        <h5>{ design.name }</h5>

                        <a class="btn default xs" onClick={ () => this.removeDesign(design) }>Remove</a>
                        <a class="btn primary xs" onClick={() => this.goToDesign(design)}>Load</a>
                    </div>
                </div>
            )
        })

        return (
            <div id="app-aside-my-designs" class="aside-text">
                <div class="scroller no-top pad">
                    <h3>My designs</h3>
                    <div style="display: flex; flex-wrap: wrap">
                        { memberDesignsContent }
                    </div>
                </div>
            </div>
        )
    }
}